module.exports = __webpack_public_path__ + "img/ACCOUNTING.0070cbe4.svg";